import React from 'react';
import { useWidgetContext } from 'widget/widget-context';

interface ButtonParams {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
}

const Ball = ({ children, href, onClick }: ButtonParams) => {
  const { setIsWidgetActive } = useWidgetContext();

  const handleClick = () => {
    setIsWidgetActive(false);
    if (onClick) onClick();
  };

  const params = {
    children: <div className="whatcrm-widget-ball__box">{children}</div>,
    className: 'whatcrm-widget-ball',
    onClick: handleClick,
  };

  return href ? (
    <a
      {...params}
      href={href.replace('/t.me/', '/telegram.me/')}
      rel="noreferrer"
      target="_blank"
    />
  ) : (
    <button {...params} type="button" />
  );
};

export default Ball;
